<template>
  <div class="min-h-screen">
    <a href="#main-content" class="skip-link">Skip to content</a>
    <header class="relative isolate overflow-hidden border-t-4 border-gold" :class="mode === 'applicant' ? 'bg-[#101010]' : 'bg-white'">
      <template v-if="mode === 'applicant'">
        <img
          src="/images/enrollment-gathering-1280.webp"
          srcset="/images/enrollment-gathering-640.webp 640w, /images/enrollment-gathering-1280.webp 1280w, /images/enrollment-gathering-1920.webp 1920w"
          sizes="100vw"
          width="1280" height="853"
          alt=""
          class="absolute inset-0 -z-20 h-full w-full object-cover object-[42%_22%] grayscale"
          fetchpriority="high" decoding="async"
        >
        <div aria-hidden="true" class="absolute inset-0 -z-10 bg-gradient-to-r from-black/90 via-black/65 to-black/30"></div>
      </template>
      <div class="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 md:px-8" :class="mode === 'applicant' ? 'py-7 md:py-10' : 'py-5 md:py-6'">
        <a href="https://peacemakersonline.com/" class="flex items-center gap-3" aria-label="Peacemakers Institute home">
          <span><span class="block font-display text-[22px] font-extrabold leading-none tracking-tight md:text-[26px]" :class="mode === 'applicant' ? 'text-white' : 'text-black'">PEACEMAKERS</span><span class="mt-3 block text-[10px] tracking-[0.18em]" :class="mode === 'applicant' ? 'text-white/90' : 'text-slate-600'">SCHOOL OF THEOLOGY</span></span>
        </a>
        <a :href="mode === 'admin' ? '/users.html#/students' : '/'" class="text-sm font-medium underline" :class="mode === 'applicant' ? 'text-white' : 'text-ink'">{{ mode === 'admin' ? 'Student administration' : 'Student sign in' }}</a>
      </div>
      <div v-if="mode === 'applicant'" class="mx-auto max-w-7xl px-5 pb-9 pt-4 md:px-8 md:pb-14 md:pt-8"><h1 class="border-l-2 border-gold pl-5 text-3xl text-white md:text-4xl">{{ applicantTitle }}</h1></div>
    </header>
    <main id="main-content" tabindex="-1" class="mx-auto max-w-7xl px-5 py-8 md:px-8 md:py-12">
      <div v-if="loading" role="status" class="card">Loading…</div>
      <div v-else-if="error" role="alert" class="error">{{ error }} <button class="ml-2 underline" @click="load">Try again</button></div>
      <template v-else>
        <div v-if="settings.sandbox || settings.draft" class="notice mb-8">{{ settings.sandbox ? 'Test enrollment — no real payments will be collected.' : '' }} {{ settings.draft ? 'Application and agreement wording is a draft for review.' : '' }}</div>
        <Admin v-if="mode === 'admin'" />
        <Tuition v-else-if="mode === 'tuition'" />
        <Applicant v-else :settings="settings" @page-title="applicantTitle = $event" />
      </template>
    </main>
    <footer class="mx-auto max-w-7xl border-t border-slate-200 px-6 py-8 text-sm text-slate-500">
      <div class="flex flex-wrap justify-between gap-4"><span>Peacemakers School of Theology</span><div class="flex flex-wrap gap-x-6 gap-y-3"><a href="https://peacemakersonline.com/school-of-theology/pricing/" class="text-ink underline">Tuition information</a><a href="mailto:admissions@peacemakersonline.com" class="break-all text-ink underline">admissions@peacemakersonline.com</a></div></div>
    </footer>
  </div>
</template>
<script>
import { api, errorMessage } from './api';
import Applicant from './Applicant.vue';
import Admin from './Admin.vue';
import Tuition from './Tuition.vue';
export default {
  components: { Applicant, Admin, Tuition },
  data: () => ({ applicantTitle: 'Apply to Peacemakers', settings: {}, loading: true, error: '', mode: location.pathname.includes('admissions') ? 'admin' : location.pathname.includes('tuition') ? 'tuition' : 'applicant' }),
  created() { this.load(); },
  methods: { async load() { this.loading = true; this.error = ''; try { this.settings = (await api.get('/settings')).data; } catch (e) { this.error = errorMessage(e); } finally { this.loading = false; } } }
};
</script>
